import { ISearchReynoldsInventoryResponse } from "@/Motivators/api/specialUnits/queries";
import { Box, Button, CircularProgress, Collapse, List, ListItem, Paper, Stack, Typography } from "@mui/material";
import clsx from "clsx";

import { ReactComponent as ArrowDown } from "@/assets/icons/actions/ArrowDown.svg";
import { ReactComponent as ArrowUp } from "@/assets/icons/actions/ArrowUp.svg";
import { useManagedSpecialUnits } from "@/Motivators/context/SpecialUnits/ManagedContext";

interface IResultsListProps {
	searchResponse: ISearchReynoldsInventoryResponse[];
	loading: boolean;
	message?: string;
}

export const ResultsList = (props: Readonly<IResultsListProps>) => {
	const { searchResponse, loading, message } = props;

	const { setHidePanelResponse, hidePanelResponse } = useManagedSpecialUnits();

	if (!loading && !message && !searchResponse?.length) {
		return null;
	}

	return (
		<Stack className="grow" alignItems="center" direction="column">
			<Collapse className="w-full" in={!hidePanelResponse} unmountOnExit={false}>
				{loading && (
					<Paper className="w-full h-[30px]">
						<Box className="flex h-full" justifyContent="center" alignItems="center">
							<CircularProgress color="inherit" size={20} />
						</Box>
					</Paper>
				)}
				{!loading && message && (
					<Paper className="w-full h-[30px]">
						<Box className="flex h-full" justifyContent="center" alignItems="center">
							<Typography className={"regular-pt-sans-pro-narrow-label fs-15"}>{message}</Typography>
						</Box>
					</Paper>
				)}
				{!loading && !message && (
					<Paper className="w-full max-h-[268px] overflow-auto">
						<List className="!py-0">
							{searchResponse?.map((item) => (
								<ListItem key={item._id} className="h-[26.8px] !py-2 hover:!bg-[#f0f0f0] !bg-transparent">
									<Typography className="!font-sans text-default !text-[14.5px]/[18.76px]">
										{`${item.make} ${item.model} (${item.year}) ${item.trim} - ${item.stockId}`}
									</Typography>
								</ListItem>
							))}
						</List>
					</Paper>
				)}
			</Collapse>
			<Button
				className={clsx("!bg-primary !text-white w-24 h-[19px] !rounded-t-none !rounded-b-[10px]", {
					"": hidePanelResponse,
				})}
				onClick={() => setHidePanelResponse(!hidePanelResponse)}
			>
				{hidePanelResponse ? <ArrowDown /> : <ArrowUp />}
			</Button>
		</Stack>
	);
};
